import React, { Component } from 'react';

class InventoryItem extends Component {
    constructor(props) {
        super(props);
        this.state = { param: props.match.params.number}
    }


    render() {
        return (
            <div className="InventoryItem">
                <p> {this.state.param} </p>
            </div>
        );
    }
};

export default InventoryItem;



// WEBPACK FOOTER //
// ./src/components/App/components/Main/components/Analytics/InventoryItem/InventoryItem.js